export enum Theme {
  Light = 'Light',
  Dark = 'Dark',
}

export type ThemeContextProps = {
  theme: Theme;
  changeTheme(value: Theme): void;
};
